// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__120Ty","print":"styles_print__SwjN-"};